import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f9f454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-head box-shadow bg-white d-flex align-items-start justify-content-between gap-3 p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-message-3-line me-2" }),
    /*#__PURE__*/_createTextVNode("Mensagem inicial da URA ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "Personalize a apresentação, o aviso e os emojis exibidos no primeiro menu.")
], -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-edit-line me-1" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger d-flex justify-content-between align-items-center gap-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-alert-line me-2" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "row g-4"
}
const _hoisted_11 = { class: "col-xl-7" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center gap-2 mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "initial-presentation",
  class: "form-label mb-0"
}, "Texto de apresentação", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block mt-1" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, "{client_name}"),
  /*#__PURE__*/_createTextVNode(" onde quiser inserir o primeiro nome. O marcador é opcional e a formatação do WhatsApp é aceita. ")
], -1))
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "initial-notice",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Aviso depois das opções "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal" }, "(opcional)")
], -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Emojis das opções", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-3" }, "Informe no máximo um emoji. Os nomes e o funcionamento das opções não serão alterados.", -1))
const _hoisted_22 = { class: "option-list" }
const _hoisted_23 = { class: "option-number" }
const _hoisted_24 = ["onUpdate:modelValue", "aria-label", "disabled"]
const _hoisted_25 = { class: "option-name" }
const _hoisted_26 = { class: "option-row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "option-number" }, "0", -1))
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "option-name" }, "Falar com atendente", -1))
const _hoisted_30 = { class: "col-xl-5" }
const _hoisted_31 = { class: "preview-panel" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-panel__title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-whatsapp-line me-2" }),
  /*#__PURE__*/_createTextVNode("Pré-visualização")
], -1))
const _hoisted_33 = { class: "preview-message" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = {
  key: 0,
  class: "alert alert-warning mb-3"
}
const _hoisted_36 = {
  key: 1,
  class: "alert alert-danger mb-3"
}
const _hoisted_37 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_41 = {
  key: 1,
  class: "ri-save-line me-2"
}
const _hoisted_42 = {
  key: 1,
  class: "row g-4"
}
const _hoisted_43 = { class: "col-xl-7" }
const _hoisted_44 = { class: "summary-block" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Apresentação", -1))
const _hoisted_46 = { class: "summary-block mb-0" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Aviso", -1))
const _hoisted_48 = { class: "col-xl-5" }
const _hoisted_49 = { class: "preview-panel" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-panel__title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-whatsapp-line me-2" }),
  /*#__PURE__*/_createTextVNode("Pré-visualização atual")
], -1))
const _hoisted_51 = { class: "preview-message" }
const _hoisted_52 = {
  key: 2,
  class: "alert alert-success mt-4 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanFeatureLocked = _resolveComponent("PlanFeatureLocked")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card mb-4 radius-7 plan-locked-wrapper initial-message-config", { 'plan-locked-wrapper--message': _ctx.disabledByPlan }])
  }, [
    (_ctx.disabledByPlan)
      ? (_openBlock(), _createBlock(_component_PlanFeatureLocked, {
          key: 0,
          overlay: "",
          title: "Mensagem inicial bloqueada pelo plano",
          message: "O plano atual não inclui atendimento automático pelo WhatsApp."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.isEditing && _ctx.configuration)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary btn-sm flex-shrink-0",
            disabled: _ctx.disabledByPlan,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args)))
          }, [
            _hoisted_4,
            _createTextVNode("Editar ")
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["card-body position-relative", { 'opacity-50': _ctx.disabledByPlan }])
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_ctx.loadError && !_ctx.configuration)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, [
                _hoisted_9,
                _createTextVNode(_toDisplayString(_ctx.loadError), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-danger",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadConfiguration && _ctx.loadConfiguration(...args)))
              }, "Tentar novamente")
            ]))
          : (_ctx.configuration)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.insertClientName && _ctx.insertClientName(...args)))
                            }, " Inserir {client_name} ")
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            id: "initial-presentation",
                            ref: "presentationTextarea",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.draft.presentation_text) = $event)),
                            class: "form-control message-textarea",
                            rows: "6",
                            maxlength: "2000",
                            disabled: _ctx.saving
                          }, null, 8, _hoisted_15), [
                            [_vModelText, _ctx.draft.presentation_text]
                          ]),
                          _hoisted_16
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("textarea", {
                            id: "initial-notice",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.draft.notice_text) = $event)),
                            class: "form-control message-textarea",
                            rows: "4",
                            maxlength: "1500",
                            disabled: _ctx.saving,
                            placeholder: "Ex.: ⚠️ IMPORTANTE:\nOs valores serão reajustados a partir de..."
                          }, null, 8, _hoisted_19), [
                            [_vModelText, _ctx.draft.notice_text]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_20,
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.options, (option) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: option.id,
                                class: "option-row"
                              }, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.optionNumber(option.id)), 1),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((option.emoji) = $event),
                                  class: "form-control emoji-input",
                                  maxlength: "16",
                                  "aria-label": `Emoji de ${option.name}`,
                                  disabled: _ctx.saving,
                                  placeholder: "—"
                                }, null, 8, _hoisted_24), [
                                  [_vModelText, option.emoji]
                                ]),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(option.name), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.draft.attendant_emoji) = $event)),
                                class: "form-control emoji-input",
                                maxlength: "16",
                                "aria-label": "Emoji de Falar com atendente",
                                disabled: _ctx.saving,
                                placeholder: "—"
                              }, null, 8, _hoisted_28), [
                                [_vModelText, _ctx.draft.attendant_emoji]
                              ]),
                              _hoisted_29
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("pre", _hoisted_33, _toDisplayString(_ctx.previewMessage), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.validationError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.validationError), 1))
                          : _createCommentVNode("", true),
                        (_ctx.loadError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.loadError), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            disabled: _ctx.saving,
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args)))
                          }, "Cancelar", 8, _hoisted_38),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success",
                            disabled: _ctx.saving || Boolean(_ctx.validationError),
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveConfiguration && _ctx.saveConfiguration(...args)))
                          }, [
                            (_ctx.saving)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                              : (_openBlock(), _createElementBlock("i", _hoisted_41)),
                            _createTextVNode(_toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar configuração'), 1)
                          ], 8, _hoisted_39)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("pre", null, _toDisplayString(_ctx.configuration.presentation_text), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("pre", null, _toDisplayString(_ctx.configuration.notice_text || 'Nenhum aviso configurado.'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("pre", _hoisted_51, _toDisplayString(_ctx.currentPreviewMessage), 1)
                        ])
                      ])
                    ])),
                (_ctx.successMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.successMessage), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
    ], 2)
  ], 2))
}